module.exports = __webpack_public_path__ + "static/media/login-background.ff92f4cf.png";